export default "__VITE_ASSET__BO2Zbc28__$_?w=600&format=webp__"